<h1>New Deal Desk Request</h1>

@if (form)
{
<form [formGroup]="form" (ngSubmit)="submit()" class="container mt-3">
    @let controls = form.controls;

    <!-- Customer Info -->
    <fieldset>
        <legend>Customer</legend>

        <dai-form-group for="customer-name" label="Customer Name" [controller]="controls.customerName">
            <input #inputRef id="customer-name" formControlName="customerName" />
        </dai-form-group>

        <dai-form-group for="customer-address" label="Customer Address" [controller]="controls.customerAddress">
            <input #inputRef id="customer-address" formControlName="customerAddress" />
        </dai-form-group>

        <dai-form-group for="customer-telephone" label="Customer Telephone" [controller]="controls.customerTelephone">
            <input #inputRef id="customer-telephone" formControlName="customerTelephone" />
        </dai-form-group>

        <dai-form-group for="decision-maker" label="Decision Maker POC" [controller]="controls.decisionMakerPOC">
            <input #inputRef id="decision-maker" placeholder="Name and Title" formControlName="decisionMakerPOC" />
        </dai-form-group>

        <dai-form-group for="last-decision-maker-contact" label="Last Decision Maker Contact"
            [controller]="controls.lastDecisionMakerContact">
            <div class="input-group">
                <input placeholder="yyyy-mm-dd" formControlName="lastDecisionMakerContact" #inputRef
                    id="last-decision-maker-contact" ngbDatepicker
                    [maxDate]="{year: todayDate.getFullYear(), month: todayDate.getMonth() + 1, day: todayDate.getDate()}"
                    [autoClose]="true" #lastContactPicker="ngbDatepicker" (focus)="lastContactPicker.open()"
                    (dateSelect)="lastContactPicker.close()" />
            </div>
        </dai-form-group>
    </fieldset>

    <!-- Opportunity -->
    <fieldset>
        <legend>Opportunity</legend>

        <dai-form-group for="current-opportunity" label="Current Opportunity"
            [controller]="controls.currentOpportunityDescription">
            <textarea #inputRef id="current-opportunity" rows="4"
                placeholder="Include proposed DAI products and/or services (quantities, prices, opportunity description)"
                formControlName="currentOpportunityDescription"></textarea>
        </dai-form-group>

        <dai-form-group for="competitive-situation" label="Competitive Situation"
            [controller]="controls.competitiveSituationDescription">
            <textarea #inputRef id="competitive-situation" rows="4"
                placeholder="Competitor, installed base (quantity and product model), quoted prices, and/or any specific T&amp;Cs modifications"
                formControlName="competitiveSituationDescription"></textarea>
        </dai-form-group>

        <dai-form-group for="procurement-stage" label="Procurement Stage" [controller]="controls.procurementStage">
            <select #inputRef id="procurement-stage" formControlName="procurementStage">
                @for (stage of procurementStages; track stage) {
                <option [value]="stage">{{ stage }}</option>
                }
            </select>
        </dai-form-group>
    </fieldset>

    <!-- Pricing -->
    <fieldset>
        <legend>Pricing</legend>

        <dai-form-group for="price-type" label="Price Type" [controller]="controls.priceType">
            <select #inputRef id="price-type" formControlName="priceType">
                <option [value]="'list'">List</option>
                <option [value]="'dealer'">Dealer</option>
            </select>
        </dai-form-group>

        <dai-form-group for="discount-requested" label="Discount Requested"
            [controller]="controls.discountRequested">
            <dai-percent-input #inputRef id="discount-requested"
                formControlName="discountRequested"></dai-percent-input>
        </dai-form-group>
    </fieldset>

    <!-- Submit -->
    <div class="mt-4 row">
        <button class="col-12 col-md-2 offset-md-2 btn btn-primary" type="submit"
            [disabled]="form.invalid || submitting">Submit</button>
    </div>
</form>
}
@else {
<app-loading></app-loading>
}
